import { Image, useWindowDimensions } from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import { Animated, Easing } from 'react-native'
import { isMobileWidth } from '../../util/util'

export const RewardAnimation = ({ src, isLeft, expandAnimation, collapseAnimation }: any) => {
  const viewportWidth = useWindowDimensions()
  const isMob = isMobileWidth(viewportWidth)
  const [rotateAnimation] = useState(new Animated.Value(0))
  const interpolateRotating = (isLeft: boolean) => {
    return rotateAnimation.interpolate({
      inputRange: [0, 1],
      outputRange: isLeft ? ['0deg', '-12deg'] : ['0deg', '12deg'],
    })
  }

  const animatedRotationStyle = (isLeft: boolean) => {
    return {
      transform: [
        {
          rotate: interpolateRotating(isLeft),
        },
      ],
    }
  }

  const startAnimation = () => {
    Animated.timing(rotateAnimation, {
      toValue: expandAnimation ? 1 : 0,
      duration: 500,
      easing: Easing.linear, // Easing is an additional import from react-native
      useNativeDriver: true, // To make use of native driver for performance
    }).start()
  }

  useEffect(() => {
    if (expandAnimation || collapseAnimation) {
      startAnimation()
    }
  }, [expandAnimation, collapseAnimation, startAnimation])

  return (
    <Animated.View
      style={[
        animatedRotationStyle(isLeft),
        isLeft
          ? { zIndex: -1, left: 0, paddingBottom: isMob ? 98 : 200 }
          : { position: 'absolute', left: 0, zIndex: -1, paddingBottom: isMob ? 98 : 200 },
      ]}>
      <Image source={src} width={isMob ? 99 : 200} height={isMob ? 99 : 200} resizeMode={'center'} />
    </Animated.View>
  )
}
